import {
  watchForBrandEditSave,
  watchForBrandEditStart,
} from './BrandEdit/brand-edit.saga';
import {
  watchForPublishStory,
  watchForUnpublishStory,
} from './StoryPublish/story-publish.saga';
import { watchForFetchCmsBrands } from './Entities/CmsBrands/cmsbrands.saga';
import {
  watchForFetchClusterById,
  watchForRemoveClusterEditStory,
  watchForSetClusterEditStories,
  watchForSubmitClusterEdit,
  watchForDeleteCluster,
  watchForReorderClusterEditStories,
} from './ClusterEdit/cluster-edit.saga';
import {
  watchForBrandAdd,
  watchForBrandListLoad,
  watchForBrandListPagination,
} from './BrandList/brandlist.saga';
import { watchForFetchAutoSuggestOutfit } from './Entities/Outfits/outfits.saga';
import {
  watchForAddStreamConfigActiveFilterItem,
  watchForAddStreamActiveFilterItems,
  watchForRemoveStreamConfigActiveFilterItem,
  watchForStreamConfigCategorySelect,
  watchForToggleBlacklistForFilter,
} from './StreamCategoryConfig/stream-category-config.saga';
import { all, spawn } from 'redux-saga/effects';
import { watchForLogin, watchForLoginSuccess } from './Auth/auth.saga';
import {
  watchForStoryListLoad,
  watchForStoryListPagination,
  watchForStoryListSelect,
  watchForStoryListToggleFilter,
  watchForStorySearch,
} from './StoryList/storylist.saga';
import { watchForCompleteRehydration } from './Config/config.saga';
import {
  watchForStoryCreate,
  watchRedirectToCreate,
} from './Entities/Stories/stories.saga';
import {
  watchForClusterListLoad,
  watchForClusterSearch,
  watchForClusterListPagination,
} from './ClusterList/clusterlist.saga';
import {
  watchForNavigation,
  watchForGoToShopEntity,
  watchForNavigateBack,
} from './Navigation/navigation.saga';
import { watchForFetchAutoSuggestProduct } from './Entities/Products/products.saga';
import { watchForUploadMedia } from './Entities/Media/media.saga';
import {
  watchDeleteSourceCategory,
  watchForAddStoryEditTargetCategory,
  watchForElementRowSave,
  watchForRemoveStoryEditTargetCategory,
  watchForSetStoryEditDates,
  watchForStoryEditStart,
  watchForStreamCategoryUpdate,
  watchForRehydrateStreamCategory,
  watchForTeaserSave,
  watchForTeaserVideoSave,
  watchSaveStory,
  watchForCountryChange,
  watchForUpdateHeadlinesByLanguagegroupForAppId,
  watchForCopyDates,
  watchForProductsForApp,
  watchDeleteProductFromAppConfig,
  watchDeleteOutfitFromAppConfig,
  watchForCopyStream,
  watchForOutfitsForApp,
  watchForCopyTargetCategories,
  watchForCopyBoostedProducts,
} from './StoryEdit/story-edit.saga';
import { watchForCountryCreate } from './Country/country.saga';
import { watchIdolFetch, watchSaveIdol } from './Entities/Idols/idols.saga';
import { watchForLoadFeaturedClusters } from './Entities/FeaturedCluster/featured-cluster.saga';
import {
  watchForFeatureClusterEditStart,
  watchForFeatureClusterEditReorder,
  watchForFeaturedClusterEditSave,
  watchForFeaturedClusterEditAddCluster,
  watchForFeaturedClusterEditRemoveCluster,
} from './FeaturedClusterEdit/featured-cluster-edit.saga';
import {
  watchForFetchProductCountForCategories,
  watchForFetchCategoryMap,
} from './CopyStreamCategories/copy-stream-categories.saga';

export function* rootSaga() {
  yield all([
    spawn(watchForLogin),
    spawn(watchForLoginSuccess),
    spawn(watchForStorySearch),
    spawn(watchForCompleteRehydration),
    spawn(watchForStoryListLoad),
    spawn(watchForStoryListPagination),
    spawn(watchForClusterListLoad),
    spawn(watchForClusterSearch),
    spawn(watchForClusterListPagination),
    spawn(watchForStoryCreate),
    spawn(watchForNavigation),
    spawn(watchForFetchAutoSuggestProduct),
    spawn(watchForUploadMedia),
    spawn(watchForStreamConfigCategorySelect),
    spawn(watchForToggleBlacklistForFilter),
    spawn(watchForAddStreamConfigActiveFilterItem),
    spawn(watchForAddStreamActiveFilterItems),
    spawn(watchForRemoveStreamConfigActiveFilterItem),
    spawn(watchForStoryEditStart),
    spawn(watchForStreamCategoryUpdate),
    spawn(watchForRehydrateStreamCategory),
    spawn(watchForFetchAutoSuggestOutfit),
    spawn(watchForStoryListSelect),
    spawn(watchForAddStoryEditTargetCategory),
    spawn(watchForRemoveStoryEditTargetCategory),
    spawn(watchForSetStoryEditDates),
    spawn(watchDeleteSourceCategory),
    spawn(watchForElementRowSave),
    spawn(watchForTeaserSave),
    spawn(watchForTeaserVideoSave),
    spawn(watchForCountryCreate),
    spawn(watchSaveStory),
    spawn(watchForCountryChange),
    spawn(watchForUpdateHeadlinesByLanguagegroupForAppId),
    spawn(watchForFetchClusterById),
    spawn(watchRedirectToCreate),
    spawn(watchForBrandListLoad),
    spawn(watchForBrandListPagination),
    spawn(watchForSetClusterEditStories),
    spawn(watchForRemoveClusterEditStory),
    spawn(watchForSubmitClusterEdit),
    spawn(watchForFetchCmsBrands),
    spawn(watchForPublishStory),
    spawn(watchForStoryListToggleFilter),
    spawn(watchForBrandAdd),
    spawn(watchForBrandEditStart),
    spawn(watchForBrandEditSave),
    spawn(watchIdolFetch),
    spawn(watchSaveIdol),
    spawn(watchForCopyDates),
    spawn(watchForCopyTargetCategories),
    spawn(watchForCopyBoostedProducts),
    spawn(watchForProductsForApp),
    spawn(watchForOutfitsForApp),
    spawn(watchDeleteProductFromAppConfig),
    spawn(watchDeleteOutfitFromAppConfig),
    spawn(watchForGoToShopEntity),
    spawn(watchForNavigateBack),
    spawn(watchForLoadFeaturedClusters),
    spawn(watchForFeatureClusterEditStart),
    spawn(watchForFeatureClusterEditReorder),
    spawn(watchForFeaturedClusterEditSave),
    spawn(watchForFeaturedClusterEditAddCluster),
    spawn(watchForFeaturedClusterEditRemoveCluster),
    spawn(watchForUnpublishStory),
    spawn(watchForDeleteCluster),
    spawn(watchForReorderClusterEditStories),
    spawn(watchForCopyStream),
    spawn(watchForFetchProductCountForCategories),
    spawn(watchForFetchCategoryMap),
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas.ts